import React, {useEffect, useState} from 'react'
import DeckApi from '../logic/DeckApi'
import {Deck} from '../model/models'
import {useNavigate} from 'react-router-dom'
import DeckMasonry from '../components/DeckMasonry'

const api = new DeckApi()

export default function MyDecks({hidePublicDecksLink}: {hidePublicDecksLink?: boolean}) {
  const [loading, setLoading] = useState<boolean>(true)
  const [decks, setDecks] = useState<Deck[]>([])

  const navigate = useNavigate()
  
  useEffect(() => {
    let isCanceled = false
    
    api.getAllUserDecks().then(decksResponse => {
      if (decksResponse.isError()) {
        console.error('error getting decks', decksResponse.exception?.toJson())
        navigate('/error')
        return
      }
      const decks = decksResponse.data!
      setDecks(decks)
    }).catch(err => {
      console.log('error getting decks', err)
    }).finally(() => {
      if (!isCanceled) setLoading(false)
    })
    
    return () => {
      isCanceled = true
    }
  }, [])
  
  return (
    <>
      <DeckMasonry
        title="My Decks"
        decks={decks}
        isPublic={false}
        loading={loading}
        hidePublicDecksLink={hidePublicDecksLink}
        isAnon={false}
        onAddPublic={() => {}}
      />
      {!loading && decks && decks.length === 0 && <p>Create or Save your first deck!</p>}
    </>
  )
}
